module.exports = __webpack_public_path__ + "public/images/zeroState.1319e941ba7df29a1b42780c08e6fd1e.svg";